import React from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Dropdown
} from 'semantic-ui-react';


/* props:
editMode bool, contactTypes array, onAddNewContact fn, onDeleteContact fn, contacts array
*/

// in student create, contacts are added and changed locally, so onAddNewContact and onDeleteContact
// need to append their own ids for this component to know on which contacts to call delete.
export default class ContactFormSegment extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            room: null,
            organizationalUnitProperty: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onAddNewOrganizationalUnitProperty = this.onAddNewOrganizationalUnitProperty.bind(this);
    }

    onAddNewOrganizationalUnitProperty() {
        const roomOrganizationalUnitProperty = {
            organizationalUnitProperty: { id: this.state.organizationalUnitProperty }
        };

        this.props.onAddNewOrganizationalUnitProperty(roomOrganizationalUnitProperty);
    }

    UNSAFE_componentWillMount() {
        this.setState({ room: this.props.room });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // console.log('Novi props: ', nextProps.room);
        this.setState({
            room: nextProps.room,
        });
    }

    getOrganizationalUnitPropertyName(organizationalUnitProperty) {
        return organizationalUnitProperty.text;
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <React.Fragment>
                { !!this.state.room.organizationalUnitProperties.length &&
                <Segment>
                    <Table compact size="small">
                        <Table.Body>
                            {this.state.room.organizationalUnitProperties.map(el =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell>
                                        {this.getOrganizationalUnitPropertyName(el)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.props.editMode &&
                                            <Button
                                                floated="right"
                                                basic
                                                color="red"
                                                size="small"
                                                onClick={() => this.props.onDeleteRoomOrganizationalUnitProperty(el.id)}
                                            >Obriši</Button>
                                        }
                                    </Table.Cell>
                                </Table.Row>))}
                        </Table.Body>
                    </Table>
                </Segment>}
                {this.props.editMode && <Segment>
                    <Header as="h5">Dodaj novoj imovini organizacione jedinice</Header>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                control={Dropdown}
                                value={this.state.organizationalUnitProperty}
                                options={this.props.organizationalUnitProperties}
                                placeholder="Odaberite imovinu organizacione jedinice"
                                onChange={this.handleInputChange}
                                name="organizationalUnitProperty"
                            />
                            <Button primary onClick={this.onAddNewOrganizationalUnitProperty}>Dodavanje</Button>
                        </Form.Group>
                    </Form>
                </Segment>}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Premises/RoomOrganizationalUnitProperty.js